<div class="sidebar">
    <div id="sidebar-collapse">
        <div class="admin-block d-flex" style="align-items: center;">
            <div>
                <img src="./../../../assets/img/dash/ap.png" class="img-circle" width="45px" />
            </div>
            <div class="admin-info">
                <div class="font-strong" (click)="home()">{{auth.allSystemModuleObj['ACCOUNT']}}</div>
            </div>
        </div>
        <ul class="side-menu metismenu">
            <li>
                <a (click)="refreshCol()"   [hidden]="sidebar['dashbord']" routerLink="/accounts/accounts-index"><i
                        class="sidebar-item-icon fa fa-th-large"></i>
                    <span class="nav-label">{{mainService.allLableShowObj[mainService.language_cd+'Sidebar1']}}
                        <!-- Dashboard -->
                    </span>
                </a>
            </li>

            <li >
                <a href="javascript:;"  data-bs-toggle="collapse" data-bs-target="#collapseReport" aria-expanded="false" aria-controls="collapseReport">
                  <i class="text-decoration-none sidebar-item-icon fa fa-bar-chart"></i>
                    <span class="nav-label text-decoration-none">{{mainService.allLableShowObj[mainService.language_cd+'Sidebar2']}}
                        <!-- Report -->
                    </span><i class="fa fa-angle-left arrow"></i></a>
                <ul class="nav-2-level collapse"  id="collapseReport" data-bs-parent="#sidebar-collapse">

                    <li>
                        <a routerLink="/accounts/ledger/report/ledger-report" [hidden]="sidebar['ledger_report']"
                           >{{mainService.allLableShowObj[mainService.language_cd+'Sidebar4']}}
                            <!-- Ledger Report -->
                        </a>
                    </li>
                    <li>
                        <a routerLink="/accounts/ledger/report/bank-report" [hidden]="sidebar['bank_book']"
                             >{{mainService.allLableShowObj[mainService.language_cd+'Sidebar5']}}
                            <!-- Bank Book -->
                        </a>
                    </li>
                    <li>
                        <a routerLink="/accounts/ledger/report/gst" [hidden]="sidebar['gst_report']"
                             >{{mainService.allLableShowObj[mainService.language_cd+'Sidebar6']}}
                            <!-- GST -->
                        </a>
                    </li>
                    <li>
                        <a routerLink="/accounts/ledger/report/tds-gst" [hidden]="sidebar['tds_on_gst']"
                             >{{mainService.allLableShowObj[mainService.language_cd+'Sidebar7']}}
                            <!-- TDS on GST -->
                        </a>
                    </li>
                    <li>
                        <a routerLink="/accounts/ledger/report/tds" [hidden]="sidebar['tds']"
                             >{{mainService.allLableShowObj[mainService.language_cd+'Sidebar8']}}
                            <!-- TDS -->
                        </a>
                    </li>
                    <li>
                        <a routerLink="/accounts/ledger/report/all-ded" [hidden]="sidebar['deduction']"
                             >{{mainService.allLableShowObj[mainService.language_cd+'Sidebar9']}}
                            <!-- Deductions -->
                        </a>
                    </li>
                    <li>
                        <a routerLink="/accounts/ledger/report/balance-sheet-report" [hidden]="sidebar['balance_sheet']"
                             >Balance Sheet</a>
                    </li>
                    <li>
                        <a routerLink="/accounts/ledger/report/income-expence-report"
                              >INC/EXP Report</a>
                    </li>
                    <li>
                        <a routerLink="/accounts/ledger/report/fix-asset" 
                             >Fixed Assets Report</a>
                    </li>
                    <li>
                        <a routerLink="/accounts/ledger/report/cogs-report" 
                             >COGS Report</a>
                    </li>
                    <li>
                        <a routerLink="/accounts/ledger/report/receipts-payment" [hidden]="sidebar['receipt_payment']"
                             >Receipts & Payment</a>
                    </li>
                    <li>
                        <a routerLink="/accounts/ledger/report/budget-report"  >Budget
                            Report</a>
                    </li>
                    <li>
                        <a routerLink="/accounts/ledger/report/store-keeper-register"
                            >Fixed Assets
                            Register</a>
                    </li>
                    <!-- <li>
                        <a routerLink="/accounts/ledger/report/adhoc-report" [hidden]="sidebar['adhoc_report']"
                             >Adhoc Report</a>
                    </li> -->
                    <!--  <li>
                            <a routerLink="/accounts/ledger/report/trail-balance"  >GIS</a>
                        </li>
                        <li>
                            <a routerLink="/accounts/ledger/report/trail-balance"  >Labour Cess</a>
                        </li>
                        <li>
                            <a routerLink="/accounts/ledger/report/trail-balance"  >Royality</a>
                        </li> -->
                    <!-- <li>
                            <a routerLink="/accounts/ledger/report/trail-balance"  >LIC</a>
                        </li> -->



                </ul>
            </li>


            <li >
                <a href="javascript:;" [hidden]="sidebar['acc_payble']" data-bs-toggle="collapse" data-bs-target="#collapsePayable" aria-expanded="false" aria-controls="collapsePayable"><i class="sidebar-item-icon fa fa-money"></i>
                    <span class="nav-label">{{mainService.allLableShowObj[mainService.language_cd+'Sidebar10']}}
                        <!-- Accounts Payable -->
                    </span><i class="fa fa-angle-left arrow"></i></a>
                <ul class="nav-2-level collapse"  id="collapsePayable" data-bs-parent="#sidebar-collapse">
                    <li>
                        <a routerLink="/accounts/bill" [hidden]="sidebar['bill']"
                             >{{mainService.allLableShowObj[mainService.language_cd+'Sidebar11']}}
                            <!-- Bills -->
                        </a>
                    </li>
                    <li>
                        <a routerLink="/accounts/dep-bill" [hidden]="sidebar['dep_bill']"
                             >Department Bill
                            <!-- Bills -->
                        </a>
                    </li>
                    <li>
                        <a routerLink="/accounts/bank-payment" [hidden]="sidebar['bank_payment']"
                             >{{mainService.allLableShowObj[mainService.language_cd+'Sidebar12']}}
                            <!-- Bank Payment -->
                        </a>
                    </li>
                    <li>
                        <a routerLink="/accounts/advice" [hidden]="sidebar['advice']"
                             >{{mainService.allLableShowObj[mainService.language_cd+'Sidebar13']}}
                            <!-- Advice -->
                        </a>
                    </li>

                </ul>
            </li>

            <li  >
                <a href="javascript:;" [hidden]="sidebar['acc_receivable']" data-bs-toggle="collapse" data-bs-target="#collapseReceivable" aria-expanded="false" aria-controls="collapseReceivable"><i
                        class="sidebar-item-icon fa fa-get-pocket"></i>
                    <span class="nav-label">{{mainService.allLableShowObj[mainService.language_cd+'Sidebar14']}}
                        <!-- Accounts Receivable -->
                    </span><i class="fa fa-angle-left arrow"></i></a>
                <ul class="nav-2-level collapse"    id="collapseReceivable" data-bs-parent="#sidebar-collapse">
                    <li>
                        <a routerLink="/accounts/challan" [hidden]="sidebar['challan']"
                             >{{mainService.allLableShowObj[mainService.language_cd+'Sidebar15']}}
                            <!-- Challans -->
                        </a>
                    </li>
                    <li>
                        <a routerLink="/accounts/dep-challan" [hidden]="sidebar['dep_challan']"
                             >Department Challan
                            <!-- Bills -->
                        </a>
                    </li>
                    <!-- <li>
                            <a routerLink="/accounts/demand"
                                 >
                                Demand
                            </a>
                        </li> -->
                    <!-- <li>
                            <a routerLink="/accounts/challan"
                                 >
                                Challan Settlement
                            </a>
                        </li> -->

                </ul>
            </li>
            <!-- <li>
                    <a href="javascript:;"    routerLink="/accounts/event-group"><i class="sidebar-item-icon fa fa-th-large"></i>
                        <span class="nav-label"></span>Event-Group
                    </a>
                </li> -->
            <li  >
                <a href="javascript:;" [hidden]="sidebar['trasury']" data-bs-toggle="collapse" data-bs-target="#collapseTreasury" aria-expanded="false" aria-controls="collapseTreasury"><i class="sidebar-item-icon fa fa-id-card"></i>
                    <span class="nav-label">{{mainService.allLableShowObj[mainService.language_cd+'Sidebar17']}}
                        <!-- Treasury -->
                    </span><i class="fa fa-angle-left arrow"></i></a>
                <ul class="nav-2-level collapse"    id="collapseTreasury" data-bs-parent="#sidebar-collapse">
                    <li>
                        <a routerLink="/accounts/tresuary/contra" [hidden]="sidebar['contra']"
                             >
                            Contra
                        </a>
                    </li>
                    <li>
                        <a routerLink="/accounts/tresuary/bank-account" [hidden]="sidebar['bank_account']"
                             >{{mainService.allLableShowObj[mainService.language_cd+'Sidebar20']}}
                            <!-- Bank Account -->
                        </a>
                    </li>
                    <li>
                        <a routerLink="/accounts/tresuary/gateway-mid-configuration"
                            [hidden]="sidebar['gateway_mid_config']"  >Gateway MID
                            Configuration
                        </a>
                    </li>
                    <li>
                        <a routerLink="/accounts/closing-stock" [hidden]="sidebar['closing_stock']"
                             >Closing Stock
                        </a>
                    </li>
                </ul>
            </li>


            <li  >
                <a href="javascript:;" [hidden]="sidebar['ledger']" data-bs-toggle="collapse" data-bs-target="#collapseLedger" aria-expanded="false" aria-controls="collapseLedger"><i class="sidebar-item-icon fa fa-book"></i>
                    <span class="nav-label">{{mainService.allLableShowObj[mainService.language_cd+'Sidebar21']}}
                        <!-- Ledger -->
                    </span><i class="fa fa-angle-left arrow"></i></a>
                <ul class="nav-2-level collapse"    id="collapseLedger" data-bs-parent="#sidebar-collapse" >
                    <li>
                        <a routerLink="/accounts/ledger/jv" [hidden]="sidebar['journal']"  >
                            Journals
                        </a>
                    </li>
                    <li>
                        <a routerLink="/accounts/ledger/report/trail-balance" [hidden]="sidebar['trail_balance']"
                             >{{mainService.allLableShowObj[mainService.language_cd+'Sidebar3']}}
                            <!-- Trial Balance -->
                        </a>
                    </li>

                    <!--   <li>
                            <a routerLink="/accounts/budget"  >{{mainService.allLableShowObj[mainService.language_cd+'Sidebar24']}}
                                    Budget</a>
                        </li> -->

                    <li>
                        <a routerLink="/accounts/ledger/jrnl" [hidden]="sidebar['manual_jrnl']"
                             >
                            Manual Journal
                        </a>
                    </li>


                </ul>
            </li>

            <li  >
                <a href="javascript:;"  data-bs-toggle="collapse" data-bs-target="#collapseAdmin"
                aria-expanded="false" aria-controls="collapseAdmin" ><i
                        class="sidebar-item-icon fa fa-user-plus"></i>
                    <span class="nav-label">{{mainService.allLableShowObj[mainService.language_cd+'Sidebar29']}}
                        <!-- Administration -->
                    </span><i class="fa fa-angle-left arrow"></i></a>
                <ul class="nav-2-level collapse"    id="collapseAdmin" data-bs-parent="#sidebar-collapse">
                  <div id="adminParent">

                    <li  >
                      <a href="javascript:;" data-bs-toggle="collapse" data-bs-target="#md"
                      aria-expanded="false" aria-controls="md"><i class="sidebar-item-icon "></i>
                          <span class="nav-label">
                              <!-- {{mainService.allLableShowObj[mainService.language_cd+'Sidebar21']}} -->
                              Master Data
                          </span><i class="fa fa-angle-left arrow"></i></a>
                      <ul class="nav-3-level collapse collapse2"    id="md" data-bs-parent="#adminParent">
                          <li>
                              <a routerLink="/accounts/setting/code-value" 
                                   >{{mainService.allLableShowObj[mainService.language_cd+'Sidebar41']}}
                                  <!-- Code-Value -->
                              </a>
                          </li>
                          <li>
                              <a routerLink="/accounts/setting/fin-year" 
                                   >
                                  <!-- {{mainService.allLableShowObj[mainService.language_cd+'Sidebar23']}} -->
                                  Fiscal Year
                              </a>
                          </li>
                          <!-- <li>
                                  <a routerLink="/accounts/ledger/coa"  >{{mainService.allLableShowObj[mainService.language_cd+'Sidebar33']}} -->
                          <!-- Chart Of Account -->
                          <!-- </a>
                              </li> -->
                          <li>
                              <a routerLink="/accounts/ledger/org-hier" 
                                   >Organization
                              </a>
                          </li>

                          <li>
                              <a href="javascript:;"   
                                  routerLink="/accounts/cost-center">
                                  <span class="nav-label"></span>Cost Center
                              </a>
                          </li>

                          <li>
                              <a routerLink="/accounts/ledger/events"
                                   >
                                  <!-- {{mainService.allLableShowObj[mainService.language_cd+'Sidebar31']}} -->
                                  Business Event
                              </a>
                          </li>
                          <!--  <li>
                                  <a routerLink="/accounts/ledger/report/party-report"  >Chart of Account (Ledger)</a>
                              </li> -->

                          <li>
                              <a routerLink="/accounts/setting/poAdvance"  >Advance PO

                              </a>
                          </li>

                          <li>
                              <a routerLink="/accounts/ledger/rule" [hidden]="sidebar['acc_rule']"
                                   >{{mainService.allLableShowObj[mainService.language_cd+'Sidebar32']}}
                                  <!-- Accounting Rule -->
                              </a>
                          </li>

                      </ul>
                  </li>

                  <!--
                      <li>
                          <a routerLink="/accounts/setting/hsn"  >
                              GST
                          </a>
                      </li>
                      <li>
                          <a routerLink="/accounts/setting/deduction-mapping"  >
                              Deduction Mapping
                          </a>
                      </li> -->

                  <li>
                      <a href="javascript:;" [hidden]="sidebar['hierarchy']" data-bs-toggle="collapse" data-bs-target="#hier"
                      aria-expanded="false" aria-controls="hier">
                          <span class="nav-label">
                              Hierarchy
                          </span><i class="fa fa-angle-left arrow"></i></a>
                      <ul class="nav-2-level collapse collapse2" id="hier" data-bs-parent="#adminParent">
                          <li>
                              <a routerLink="/accounts/ledger/bud-hier" [hidden]="sidebar['bud_hier']"
                                   >{{mainService.allLableShowObj[mainService.language_cd+'Sidebar24']}}
                                  <!-- Budget Hierarchy -->
                              </a>
                          </li>
                          <li>
                              <a routerLink="/accounts/ledger/activity-hier" [hidden]="sidebar['act_hier']"
                                   >{{mainService.allLableShowObj[mainService.language_cd+'Sidebar36']}}
                                  <!-- Activity Hierarchy -->
                              </a>
                          </li>
                          <li>
                              <a routerLink="/accounts/ledger/proj-hier" [hidden]="sidebar['proj_hier']"
                                   >{{mainService.allLableShowObj[mainService.language_cd+'Sidebar35']}}
                                  <!-- Project Hierarchy -->
                              </a>
                          </li>

                          <li>
                              <a routerLink="/accounts/ledger/prod-hier" [hidden]="sidebar['prod_hier']"
                                   >{{mainService.allLableShowObj[mainService.language_cd+'Sidebar37']}}
                                  <!-- Product Hierarchy -->
                              </a>
                          </li>
                          <li>
                              <a routerLink="/accounts/ledger/coa" [hidden]="sidebar['coa']"
                                   >{{mainService.allLableShowObj[mainService.language_cd+'Sidebar33']}}
                                  <!-- Chart Of Account -->
                              </a>
                          </li>
                      </ul>
                  </li>

                  <li>
                      <a href="javascript:;" [hidden]="sidebar['security']" data-bs-toggle="collapse" data-bs-target="#sec"
                      aria-expanded="false" aria-controls="sec">
                          <span class="nav-label">
                              <!-- {{mainService.allLableShowObj[mainService.language_cd+'Sidebar42']}} -->
                              Security
                          </span><i class="fa fa-angle-left arrow"></i></a>
                      <ul class="nav-2-level collapse collapse2"  id="sec" data-bs-parent="#adminParent" >


                          <li>
                              <a routerLink="/accounts/administration/roles" [hidden]="sidebar['role']"
                                   >
                                  {{mainService.allLableShowObj[mainService.language_cd+'Sidebar43']}}
                                  <!-- Role -->
                              </a>
                          </li>
                          <li>
                              <a routerLink="/accounts/administration/users" [hidden]="sidebar['user']"
                                   >
                                  <!-- {{mainService.allLableShowObj[mainService.language_cd+'Sidebar44']}} -->
                                  Functional Authorization
                                  <!-- Users Role Authorization -->
                              </a>
                          </li>

                          <li>
                              <a routerLink="/accounts/administration/dataAuth" [hidden]="sidebar['data_auth']"
                                   >
                                  <!-- {{mainService.allLableShowObj[mainService.language_cd+'Sidebar44']}} -->
                                  Data Authorization
                                  <!-- Users Role Authorization -->
                              </a>
                          </li>
                          <li>
                              <a routerLink="/accounts/administration/account-appr" [hidden]="sidebar['workflow']"
                                   >
                                  WorkFlow
                              </a>
                          </li>

                          <!-- <li>
                                  <a routerLink="/accounts/administration/hierarchy"  >
                                          {{mainService.allLableShowObj[mainService.language_cd+'Sidebar45']}}
                                           Hierarchy
                                      </a>
                              </li> -->
                          <!-- <li>
                                  <a routerLink="/accounts/administration/data-assignment"  >
                                          {{mainService.allLableShowObj[mainService.language_cd+'Sidebar47']}}
                                          Data Assignment
                                      </a>
                              </li> -->
                          <!-- <li>
                                  <a routerLink="/accounts/administration/account-appr"  >
                                      WorkFlow
                                  </a>
                              </li> -->
                      </ul>
                  </li>

                  <li>
                      <a   routerLink="/accounts/setting/party" (click)="refreshCol2()" [hidden]="sidebar['party']">
                          <span class="nav-label">
                              Party/Vendor
                          </span>
                      </a>
                  </li>

                  <li>
                      <a   routerLink="/accounts/setting/work" (click)="refreshCol2()" [hidden]="sidebar['work']">
                          <span class="nav-label">
                              Work
                          </span>
                      </a>
                  </li>

                  <li>
                      <a routerLink="/accounts/setting/project-bank" (click)="refreshCol2()" [hidden]="sidebar['proj_bank']"
                           >
                          Project Bank Account
                      </a>
                  </li>
                  <li>
                      <a routerLink="/accounts/setting/fixed-assets-mapping"
                          [hidden]="sidebar['fixed_assets_mapping']" (click)="refreshCol2()"  >
                          Fixed Asset Mapping
                      </a>
                  </li>

                  <!-- <li>
                          <a routerLink="/accounts/setting/fields"  >Fields</a>
                      </li> -->
                  <li>
                      <a routerLink="/accounts/setting/deduction-mapping" (click)="refreshCol2()" [hidden]="sidebar['deduction_mapping']"
                           >
                          Deduction Mapping
                      </a>
                  </li>
                  <li>
                      <a routerLink="/accounts/setting/hsn" [hidden]="sidebar['gst']" (click)="refreshCol2()"
                           >GST</a>
                  </li>
                  <li>
                      <a (click)="refreshCol2()" routerLink="/accounts/setting/acc-mapping" [hidden]="sidebar['accoun_mapping']"
                           > Account Mapping
                      </a>
                  </li>
                  </div>

                </ul>
            </li>


            <li  >
                <a href="javascript:;" data-bs-toggle="collapse" data-bs-target="#collapseHelp"
                aria-expanded="false" aria-controls="collapseHelp" ><i class="sidebar-item-icon fa fa-question-circle"></i>
                    <span class="nav-label">{{mainService.allLableShowObj[mainService.language_cd+'Sidebar48']}}
                        <!-- Help -->
                    </span><i class="fa fa-angle-left arrow"></i></a>
                <ul class="nav-2-level collapse"    id="collapseHelp" data-bs-parent="#sidebar-collapse">
                    <li>
                        <a routerLink="/accounts/help/faq"
                             >{{mainService.allLableShowObj[mainService.language_cd+'Sidebar49']}}
                            <!-- FAQ -->
                        </a>
                    </li>
                    <li>
                        <a routerLink="/accounts/help/doc"
                             >{{mainService.allLableShowObj[mainService.language_cd+'Sidebar50']}}
                            <!-- User Manual -->
                        </a>
                    </li>
                    <li>
                        <a routerLink="/accounts/help/videos"
                             >{{mainService.allLableShowObj[mainService.language_cd+'Sidebar51']}}
                            <!-- Tutorial Videos -->
                        </a>
                    </li>
                    <li>
                        <a routerLink="/accounts/help/online-support"
                             >{{mainService.allLableShowObj[mainService.language_cd+'Sidebar52']}}
                            <!-- Online Support -->
                        </a>
                    </li>
                </ul>
            </li>



        </ul>
    </div>
</div>
